

import React from 'react'

const Conditions = () => {
  return (
    <div className="container my-4 py-3">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8 shadow-lg p-5 rounded bg-white">
          {/* Heading */}
          <div className="text-center mb-4">
            <h3 className="fw-bold" style={{ color: "#0564bf" }}>
              Terms & Conditions
            </h3>
          </div>

          {/* 1. Service Scope */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}> Service Scope</h5>
            <ul>
              <li>
                Services include basic cooking, dusting, mopping, sweeping,
                vacuuming, wiping surfaces, cleaning bathrooms, and kitchen
                cleaning (as agreed in the package).
              </li>
              <li>
                Services do not include deep cleaning, heavy lifting, carpet
                shampooing, or outdoor cleaning unless explicitly requested.
              </li>
            </ul>
          </div>

          {/* 2. Booking and Payment */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}> Booking and Payment</h5>
            <ul>
              <li>All payments must be made in advance before the booking is confirmed.</li>
              <li>Weekly and fortnightly packages must be prepaid for the month.</li>
              <li>One-time sessions must be paid before the day of service.</li>
              <li>Payment methods: bank transfer, UEN pay now, or digital payment as agreed.</li>
            </ul>
          </div>

          {/* 3. Agency Fee */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}> Agency Fee</h5>
            <ul>
              <li>Inclusive in the package. No hidden charges.</li>
            </ul>
          </div>

          {/* 4. Cancellations & Rescheduling */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}> Cancellations & Rescheduling</h5>
            <ul>
              <li>Cancellations must be made at least 24 hours in advance.</li>
              <li>Rescheduling is allowed once per session without additional charge; additional reschedules may incur fees.</li>
              <li>No-shows or late cancellations may result in full session charge.</li>
            </ul>
          </div>

          {/* 5. Liability */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>Liability</h5>
            <ul>
              <li>The company is insured for standard cleaning activities.</li>
              <li>The company is not responsible for pre-existing damages or items of high value unless declared in writing before service.</li>
            </ul>
          </div>

          {/* 6. Access */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>Access</h5>
            <ul>
              <li>Clients must provide access to the premises at the scheduled time.</li>
              <li>Delays caused by lack of access may result in reduced cleaning time or rescheduling.</li>
            </ul>
          </div>

          {/* 7. Termination */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>Termination</h5>
            <ul>
              <li>Either party may terminate the agreement with 15 days notice.</li>
              <li>Prepaid sessions will be refunded on a pro-rata basis if the contract is terminated early.</li>
            </ul>
          </div>

          {/* 8. Satisfaction */}
          <div className="mb-3">
            <h5 style={{ color: "#0564bf" }}>Satisfaction</h5>
            <ul>
              <li>If any cleaning task is not completed as agreed, the client must notify the company within 24 hours for corrective action.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Conditions
